/**
 * Validação de integridade da fila persistida (checksum simples).
 */

import type { QueueItem } from './queue';

export function computeQueueChecksum(items: QueueItem[]): string {
  const payload = JSON.stringify(items.map(i => i.id).sort());
  let hash = 0;
  for (let i = 0; i < payload.length; i++) {
    hash = (hash << 5) - hash + payload.charCodeAt(i);
    hash |= 0;
  }
  return `q_${Math.abs(hash)}`;
}

export function validateQueueChecksum(
  items: QueueItem[],
  expected: string
): boolean {
  return computeQueueChecksum(items) === expected;
}
